var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"card card-with-search border-0 card-with-shadow"},[_c('div',{staticClass:"text-justify"},[_c('app-tab',{attrs:{"tabs":_vm.tabsHorizontal,"type":"horizontal"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }